import type { GetContactListResponse } from "@/openapi/generated";

/** General studio contact email from the contact recipients API. */
export function getGeneralContactEmail(
  recipients: GetContactListResponse[] | null | undefined,
): string | null {
  if (!recipients?.length) return null;
  const general = recipients.find((r) => r.isGlobalContact);
  return general?.email?.trim() || null;
}
